import React, { useEffect, useState } from 'react';
import MyVisitsToday from './MyVisitsToday';

const TeacherHome = () => {
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);

  return (

    <div className="p-0">
      <MyVisitsToday />
    </div>
  );
};

export default TeacherHome;

